import React, { PureComponent } from "react";
import { Image, Icon } from "semantic-ui-react";
import { getLabel } from "../../constants/Strings";
import styles from "./MaintenanceScreen.module.css";

class MaintenanceScreen extends PureComponent {
  render() {
    return (
      <div className={styles.globalContainer}>
        <Image src="/logo3_1.png" className={styles.logo} />
        
        <div className={styles.card}>
          <Icon name="setting" loading className={styles.icon} />
          <h1 className={styles.title}>{getLabel("MaintenanceTitle")}</h1>
          <p className={styles.body}>
            {getLabel("MaintenanceBody")}
          </p>
          <div className={styles.footer}>
            © {new Date().getFullYear()} Tize Milyon.
          </div>
        </div>
      </div>
    );
  }
}

export default MaintenanceScreen;
